import InputNumberFixer from "../../../packs_helper/scripts/InputNumberFixer";
import Switcher from '../../../packs_helper/scripts/Switcher';
import Decimal from '../../../packs_helper/scripts/Decimal';
import PostData from '../../../packs_helper/scripts/PostData';

InputNumberFixer();

const quantities = document.querySelectorAll('[name="quantity]');
const costs = document.querySelectorAll('[name="cost]');
// const goldbarRows = document.querySelectorAll('.goldbar-row');
// goldbarRows.forEach(function(el){
// 	el.addEventListener('submit', function(e){
// 		e.preventDefault();
// 		const formData = new FormData(e.target);
// 		Fetch('/sepete-gonder', formData)
// 		.then(function(response){
// 			console.log(response);
// 		})
// 		.catch(function(err){
// 			console.log(err);
// 		})
// 	});
// });

const costQuantitySwitcher = document.getElementById('cost-quantity-switcher');
const goldbarContainer = document.querySelector('.goldbar-container');
const calculatePriceInputs = document.querySelectorAll('[data-calculate-price]');
const goldbarForms = document.querySelectorAll('.goldbar-row');

const event = new Event('input');
let shoppingType = 'quantity'

Switcher(costQuantitySwitcher, function(button){
	if(button.dataset.class == 'show-cost'){
		shoppingType = 'cost'
		goldbarContainer.classList.add('show-cost');
		calculatePriceInputs.forEach(function(calculatePriceInput){
			calculatePriceInput.value = 1;
			calculatePriceInput.dispatchEvent(event);
		});
	}
	else{
		shoppingType = 'quantity'
		goldbarContainer.classList.remove('show-cost');
	}
});

calculatePriceInputs.forEach(function(calculatePriceInput){
	const calculatedBys = document.querySelectorAll(`[data-calculated-by="${calculatePriceInput.dataset.calculatePrice}"]`);
	calculatePriceInput.addEventListener('input', (e) => {
		const quantity = Decimal(e.currentTarget.value);
		calculatedBys.forEach(calculatedBy => {
			const price = quantity * Decimal(calculatedBy.dataset.unitPrice);
			if(!price){
				calculatedBy.innerText = `${Decimal(calculatedBy.dataset.unitPrice).toFixed(2)} ₺`;
			}
			else{
				calculatedBy.innerText = `${price.toFixed(2)} ₺`;
			}
		})
	}, false)
})

goldbarForms.forEach(function(goldbarForm){
	goldbarForm.addEventListener('submit', e => {
		if(shoppingType === 'cost'){
			e.preventDefault();
			e.stopPropagation();
			document.body.dataset.waitForResponse = true;
			const formData = new FormData(e.currentTarget);
			const buttonAction = e.submitter;

			const cost = Decimal(formData.get('cost'));
			const unitCost = Decimal(buttonAction.dataset.cost);




			const quantity = (Math.floor(cost / unitCost * 100) / 100).toFixed(2);

			formData.set('quantity', quantity);
			formData.set('button_action', buttonAction.value);
			// debugger;

			PostData(e.currentTarget.action, formData, {rawHtml: true}).then(() => {
				document.body.dataset.waitForResponse = false;
			});
		}
	})
});
